/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=6eb01df6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6eb01df6&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=6eb01df6&lang=less"

import exportComponent from "/Users/zhangheng/Desktop/development/officialwebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eb01df6"]])

export default __exports__